import type { TipoSolicitacao, TipoFluxoMovimentacao } from '../../models';

export { TIPOS_SOLICITACAO_SEM_MOVIMENTACAO } from '../../models';

export const TIPO_SOLICITACAO_LABELS: Record<TipoSolicitacao, string> = {
  admissao: 'Admissão',
  desligamento: 'Desligamento',
  mudanca_projeto: 'Mudança de Projeto',
  troca_equipamento: 'Troca de Equipamento',
  devolucao: 'Devolução',
  pedido_colaborador: 'Solicitação de Periféricos e Acessórios',
  formatacao: 'Formatação de Equipamento',
  acessos: 'Acessos',
  // Por último de propósito (pedido do usuário) — nome genérico demais fazia parecer a
  // opção "padrão"/catch-all, levando gente a escolher errado em vez de "Solicitação de
  // Periféricos e Acessórios" pra itens avulsos/pessoais (ver comentário em
  // NovaSolicitacaoContent sobre não ter mais um tipo pré-selecionado, pelo mesmo
  // motivo). Renomeado de "Nova Demanda" — reaproveita o termo "Alocação" já usado no
  // app (Collaborators/Allocations, `alocacaoReferenciadaId`) pra "pessoa ganha um
  // projeto a mais, mantendo os que já tinha", que é o caso de uso real deste tipo.
  nova_demanda: 'Nova Alocação',
  // Só nasce pelo botão "Informar divergência" (Meus equipamentos, Portal do SI) — fora
  // do seletor de tipo do formulário (ver NovaSolicitacaoContent).
  divergencia_inventario: 'Divergência de Inventário',
};

export const TIPO_SOLICITACAO_OPCOES: Array<{ value: TipoSolicitacao; label: string }> =
  Object.entries(TIPO_SOLICITACAO_LABELS).map(([value, label]) => ({
    value: value as TipoSolicitacao,
    label,
  }));

/**
 * Tipos em que a Data (dataPrevista da 1ª Movimentação) é obrigatória e visível para
 * quem abre a Solicitação — para os demais, o campo não aparece pra quem não é SI
 * (decisão de produto: SI completa depois, ver Movimentação).
 */
export const TIPOS_SOLICITACAO_COM_DATA_OBRIGATORIA: TipoSolicitacao[] = [
  'admissao',
  'desligamento',
  'nova_demanda',
  'mudanca_projeto',
];

/**
 * Fluxo padrão da 1ª Movimentação por tipo de Solicitação — não é perguntado a quem
 * abre o pedido (é intrínseco ao tipo, não uma decisão da pessoa). "formatacao" não usa
 * esse valor (ver TIPOS_SOLICITACAO_SEM_MOVIMENTACAO) — presente só pra satisfazer o Record.
 */
export const TIPO_FLUXO_PADRAO_POR_SOLICITACAO: Record<TipoSolicitacao, TipoFluxoMovimentacao> = {
  admissao: 'envio',
  desligamento: 'devolucao',
  mudanca_projeto: 'envio',
  nova_demanda: 'envio',
  troca_equipamento: 'envio',
  devolucao: 'devolucao',
  pedido_colaborador: 'envio',
  formatacao: 'envio',
  acessos: 'envio',
  divergencia_inventario: 'envio',
};

/**
 * Esses 2 tipos sempre envolvem receber um equipamento novo E devolver o antigo — por
 * isso, ao abrir a Solicitação, criamos as 2 Movimentações de uma vez (envio + devolução)
 * em vez de só a 1ª (ver NovaSolicitacaoContent). Hardcoded por decisão explícita — se
 * outros tipos precisarem do mesmo no futuro, aí sim vale a pena ligar isso à config
 * `ConfigTipoSolicitacao.geraMovimentacaoEnvio`/`geraMovimentacaoDevolucao` (existe no
 * schema, nunca foi usada).
 */
export const TIPOS_SOLICITACAO_COM_DEVOLUCAO_AUTOMATICA: TipoSolicitacao[] = [
  'mudanca_projeto',
  'troca_equipamento',
];

/**
 * Sugere qual equipamento (só 1, com escolha manual se houver mais de um vinculado ao
 * colaborador) devolver — igual `TIPOS_SOLICITACAO_COM_DEVOLUCAO_AUTOMATICA`, mas sem
 * criar uma 2ª Movimentação: "Devolução" já nasce com `tipoFluxo: 'devolucao'` (só 1
 * Movimentação), a sugestão só enriquece o item de equipamento que já seria criado.
 */
export const TIPOS_SOLICITACAO_COM_SUGESTAO_DEVOLUCAO_UNICA: TipoSolicitacao[] = [
  'mudanca_projeto',
  'troca_equipamento',
  'devolucao',
];

/**
 * Desligamento: TODO equipamento vinculado ao colaborador será devolvido, não só um —
 * sem escolha manual, um item de equipamentosIntake por equipamento encontrado.
 */
export const TIPOS_SOLICITACAO_COM_SUGESTAO_DEVOLUCAO_TOTAL: TipoSolicitacao[] = ['desligamento'];
